import React, { useEffect } from 'react';
import WOW from 'wow.js';
import 'animate.css/animate.css';

const Footer = () => {
  useEffect(() => {
    const wow = new WOW();
    wow.init();
  }, []);

  return (
    <div className='footer-section '>
        <section className="contact-area" id="contact">
  <div className="footer-container">
    <div className="row">
      <div className="col-lg-6 offset-lg-3">
        <div className="contact-content text-center  wow animate__fadeInUp" data-wow-duration="1s" data-wow-delay="0.5s">
          <a href="#"><img src="https://i.ibb.co/k2Frnqr/Picsart-23-12-18-14-18-05-855.png" alt="logo"/></a>
          <p>Web Gurus Hub: Empowering brands with expert frontend development, stunning websites, and innovative ecommerce solutions. Unlock your digital potential and thrive in the ever-evolving digital landscape with our tailored web solutions. </p>
          <div className="hr"></div>
          <h6>Faisalabad, Punjab, Pakistan.</h6>
          <h6>+92-311-7392272<span>|</span>Web Gurus Hub</h6>
          <div className="contact-social  wow animate__fadeInUp" data-wow-duration="1s" data-wow-delay="0.5s">
            <ul>
              <li><a className="hover-target" href="https://www.facebook.com/profile.php?id=61550575350025&mibextid=ZbWKwL"><i className="fa fa-facebook"></i></a></li>
              <li><a className="hover-target" href="https://www.linkedin.com/company/webgurushub/"><i className="fa fa-linkedin"></i></a></li>
              <li><a className="hover-target" href="https://wa.me/c/923117392272"><i className="fa fa-whatsapp"></i></a></li>
              <li><a className="hover-target" href="https://www.instagram.com/webgurushub?igsh=eGZwOGp2ZTFkZWVI"><i className="fa fa-instagram"></i></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<footer>
  <p>Copyright &copy; <span tooltip="Where are Muzammal ?">2023</span> <img src="https://i.ibb.co/k2Frnqr/Picsart-23-12-18-14-18-05-855.png" alt="logo"/> All Rights Reserved.</p>
</footer>
    </div>
  )
}

export default Footer
